export default class FloorModel {
  /* tslint:disable:variable-name */
  public _id: string = ''
  public name: string = ''
  public building_name: string = ''
  public num_beacon: number = 1
  public floor_file: string = ''
  public floor_angle: number = 0
  public floor_sw_lat: number = 0
  public floor_sw_lon: number = 0
  public floor_ne_lat: number = 0
  public floor_ne_lon: number = 0
  public floor_map_zoom: number = 18
  public floor_opacity: number = 50
  public created_at: Date = new Date()
  public updated_at: Date = new Date()
}
